import pathOr from 'ramda/es/pathOr';

export default (err, header) => {
  const headers = pathOr(null, ['response', 'headers'], err);
  return headers ? pathOr(null, [header], headers) : null;
};
